// @ts-nocheck
import { ReactNode, useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { alpha, AppBar, Toolbar, useMediaQuery, AppBarProps } from '@mui/material';

// project import
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';
import IconButton from 'components/@extended/IconButton';
import useMenu from 'contexts/MenuContext';

// assets
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';

// types
import { ThemeMode } from 'types/config';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

// front-end's Header (vertical menu), with the drawer flag from MenuContext.
const Header = () => {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));
  const { drawerOpen, openDrawer } = useMenu();

  // header content
  const headerContent = useMemo(() => <HeaderContent />, []);

  const iconBackColorOpen = theme.palette.mode === ThemeMode.DARK ? 'grey.200' : 'grey.300';
  const iconBackColor = theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'grey.100';

  // common header
  const mainHeader: ReactNode = (
    <Toolbar
      sx={{
        minHeight: { xs: 56, lg: 60 },
        px: { xs: 1.25, md: 2, lg: 2.25 },
        gap: 0.75,
        '&.MuiToolbar-root': {
          minHeight: { xs: 56, lg: 60 }
        }
      }}
    >
      <IconButton
        aria-label="open drawer"
        onClick={() => openDrawer(!drawerOpen)}
        edge="start"
        color="secondary"
        variant="light"
        sx={{
          color: 'text.primary',
          bgcolor: drawerOpen ? iconBackColorOpen : iconBackColor,
          border: '1px solid',
          borderColor: alpha(theme.palette.grey[500], 0.12),
          borderRadius: '12px',
          ml: { xs: 0, lg: -0.25 },
          mr: { xs: 0.25, lg: 0.75 },
          width: 38,
          height: 38,
          '&:hover': {
            bgcolor: alpha(theme.palette.primary.main, 0.08)
          }
        }}
      >
        {!drawerOpen ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </IconButton>
      {headerContent}
    </Toolbar>
  );

  // app-bar params
  const appBar: AppBarProps = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
      zIndex: 1200,
      ...(downLG ? { left: 0, right: 0, width: 'auto' } : {}),
      bgcolor: alpha(theme.palette.background.paper, 0.78),
      backdropFilter: 'blur(18px)',
      boxShadow: `0 12px 30px ${alpha(theme.palette.common.black, theme.palette.mode === ThemeMode.DARK ? 0.32 : 0.06)}`
    }
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={drawerOpen} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
};

export default Header;
